import { getToken } from './storage';
import { TOKEN_ID_FIRST } from '../pages/oauth2/constants';
import { axiosAuth } from '../helpers/axios';

const baseUrl = process.env.REACT_APP_DISCORD_API_URL;

export const addSpecialRole = (userId) => {
  return axiosAuth(baseUrl, getToken(TOKEN_ID_FIRST)).post(`/user/${userId}/add-special-role`).then(response => response.data || {});
}
